export default {
  setTotalFee(state: { totalFee: any }, value: any) {
    state.totalFee = value;
  },

  setType(state: { type: any }, value: any) {
    state.type = value;
  },
};
